import { render, staticRenderFns } from "./douyin_aweme.vue?vue&type=template&id=7bc2f666&scoped=true"
import script from "./douyin_aweme.vue?vue&type=script&lang=js"
export * from "./douyin_aweme.vue?vue&type=script&lang=js"
import style0 from "./douyin_aweme.vue?vue&type=style&index=0&id=7bc2f666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc2f666",
  null
  
)

export default component.exports